/*
 *  -----------------------------------------------------------------------
 *    <copyright file="system-users-service.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

const getAdminLevelName = (i: number) => {
    switch (i) {
        case 1:
            return 'Reviewer';
        case 2:
            return 'Contributor';
        case 3:
            return 'Administrator';
        case 4:
            return 'System Administrator';
        default:
            return '';
    }
};

export { getAdminLevelName };
